import React, { useContext, useEffect } from 'react'
import { isEmpty } from 'lodash'

import { AdvancedTable } from '@/components/tables/AdvancedTable/AdvancedTable'
import WidgetContainer from '@/components/widget/WidgetContainer'
import WidgetContext from '@/components/widget/widget.context'
import { formatTime } from '@/utils/helpers'

const STATUS_LABELS = {
  created: 'Coaching Created',
  sent_to_agent: 'Coaching Sent to Agent',
  acknowledged: 'Coaching Acknowledged by Agent',
  manual_score_completed: 'Manual Score Completed',
  dispute_completed: 'Dispute Completed',
  calls_viewed: 'Call Views',
  coaching_calls_viewed: 'Coaching Call Views',
  kodi_sessions: 'Kodi Sessions',
}

const STATUS_DESCRIPTIONS = {
  calls_viewed: 'Data available after March 17, 2026',
  coaching_calls_viewed:
    'Calls opened inside a coaching task. Data available after November 10, 2026',
}

export const SupervisorUsageWidget = ({
  statusKeys = ['created', 'sent_to_agent', 'acknowledged'],
  data = [],
  loading = false,
  paginationPageSize = 20,
}) => {
  const { handleChangeCsvData } = useContext(WidgetContext)

  const rows =
    data?.map((manager) => {
      const statusValues = statusKeys.reduce((acc, key) => {
        acc[key] = manager.statuses[key] || 0
        return acc
      }, {})
      return {
        ...manager,
        name: `${manager.first_name} ${manager.last_name}`,
        ...statusValues,
      }
    }) || []

  const columns = [
    { accessor: 'name', label: 'Name', isSearchable: true, sticky: true },
    { accessor: 'username', label: 'Email', isSearchable: true },
    {
      accessor: 'last_cloud_login',
      label: 'Last Cloud Login',
      description: 'Data available after March 17, 2026',
      format: (value) => (value ? formatTime(value, 'MMM D, YYYY h:mm A') : '-'),
    },
    ...statusKeys.map((key) => ({
      accessor: key,
      label: STATUS_LABELS[key] || key,
      description: STATUS_DESCRIPTIONS[key],
      format: (value) => Number(value).toLocaleString(),
      headerAlignment: 'right',
    })),
  ]

  useEffect(() => {
    handleChangeCsvData({ headers: columns, data: rows })
  }, [data, statusKeys])

  return (
    <WidgetContainer
      autoHeight={!loading && !isEmpty(rows)}
      loading={loading}
      noData={isEmpty(rows)}
      withPagination
      table={
        <AdvancedTable
          index="manager_id"
          columns={columns}
          rows={rows}
          pagination
          rowsPerPage={paginationPageSize}
          defaultOrder="desc"
          defaultOrderBy="manual_score_completed"
          showDescription
        />
      }
      chart={<div />}
    />
  )
}
